import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { conferences, qr } from '../api';

const PrintQR = () => {
  const { id } = useParams();
  const [conference, setConference] = useState(null);
  const [qrCodes, setQrCodes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const confRes = await conferences.getOne(id);
        setConference(confRes.data);
        const qrRes = await qr.generate(id);
        setQrCodes(qrRes.data);
      } catch {
        setError('Kunne ikke laste data');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-cream-50">
      <p className="text-navy-400">Laster...</p>
    </div>
  );

  if (error) return (
    <div className="flex items-center justify-center h-screen bg-cream-50">
      <p className="text-red-500">{error}</p>
    </div>
  );

  return (
    <div className="min-h-screen bg-white p-8">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-10 print:mb-6">
          <p className="text-gold-600 text-xs font-bold uppercase tracking-widest mb-2">PODIUM</p>
          <h1 className="text-3xl font-bold text-navy-800">{conference?.title}</h1>
          <p className="text-navy-500 mt-1">
            {conference && new Date(conference.date).toLocaleDateString('nb-NO', {
              weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
            })}
            {conference?.end_date && ` - ${new Date(conference.end_date).toLocaleDateString('nb-NO', {
              day: 'numeric', month: 'long', year: 'numeric'
            })}`}
            {conference?.location && ` · ${conference.location}`}
          </p>
          {conference?.organizer && (
            <p className="text-navy-400 text-sm mt-1">{conference.organizer}</p>
          )}
        </div>

        <div className="grid grid-cols-2 gap-8">
          <div className="flex flex-col items-center border border-cream-200 rounded-2xl p-8 shadow-sm">
            <p className="text-lg font-bold text-navy-700 mb-1">📋 Program</p>
            <p className="text-xs text-navy-400 mb-5 text-center">Scan for å se dagens program</p>
            <QRCodeSVG value={qrCodes.program.url} size={200} />
          </div>

          <div className="flex flex-col items-center border border-cream-200 rounded-2xl p-8 shadow-sm">
            <p className="text-lg font-bold text-navy-700 mb-1">⬇️ Last ned</p>
            <p className="text-xs text-navy-400 mb-5 text-center">Scan for å laste ned presentasjonene</p>
            <QRCodeSVG value={qrCodes.download.url} size={200} />
          </div>
        </div>

        <div className="text-center mt-10 print:hidden">
          <button onClick={() => window.print()}
            className="bg-navy-700 text-white px-8 py-3 rounded-xl font-semibold hover:bg-navy-800 transition">
            🖨️ Skriv ut
          </button>
        </div>

        <p className="text-center text-xs text-navy-300 mt-8 tracking-wide print:mt-4">PODIUM · Konferanseverktøy</p>
      </div>
    </div>
  );
};

export default PrintQR;
